import {ethers, Wallet, } from "ethers";
import {joinSignature} from "ethers/lib/utils";
import { Socket } from 'socket.io-client';


type InternalMessageSigningServiceContructorParams = {
    signer: Wallet;
    provider: ethers.providers.JsonRpcProvider;
    connectedSocketConnection:Socket;
    isMobileSDK: any;
    socketUUID: string;
    isHashedMessage: boolean

}

export class InternalMessageSigningService{
    currMessage?:string;
    connectedSocketConnection:Socket
    isMobileSDK:boolean=false;
    socketUUID?:string;
    signer:Wallet;
    provider:ethers.providers.JsonRpcProvider;
    messageToSign?:string;
    redirectURL?:string;
    chainId?:number;
    personalMessage:boolean=false;
    isHashedMessage:boolean=false;
    
    constructor({signer, provider,
                 connectedSocketConnection,
                 isMobileSDK, socketUUID, isHashedMessage}:InternalMessageSigningServiceContructorParams){
        this.signer = signer;
        this.provider = provider;
        this.connectedSocketConnection = connectedSocketConnection;
        this.isMobileSDK = (isMobileSDK === 'true' || isMobileSDK=== true);
        this.isHashedMessage = isHashedMessage;
        this.socketUUID = socketUUID;
    }

    
    async parseAndSetMessageFromURI(){
        //First set transaction currency.
        const params:any = new Proxy(new URLSearchParams(
            window.location.search), {
                get: (searchParams:any, prop:any) => searchParams.get(prop),
            });
        console.log('params.signMessage', params.signMessage);
        this.messageToSign = params.signMessage;
        if(params.signPersonalMessage){
            this.messageToSign = params.signPersonalMessage;
            this.personalMessage = true;
        }
        console.log('this.messageToSign', this.messageToSign);
        this.redirectURL = params.lastLocation;
        this.chainId = params.chainId;
        this.isHashedMessage = params.hashMessage;
        this.isMobileSDK = (params.isMobileSDK === 'true' || params.isMobileSDK === true);
        return this.messageToSign
    }

    async approveMessageSign(){
        let message:any = this.messageToSign;
        //check if string is hex
        // if it is hex, then remove the 0x prefix and convert to bytes
        
        let signedMessage;
        if(this.isHashedMessage){
            signedMessage = joinSignature(this.signer._signingKey().signDigest(this.messageToSign as string));
        }else{
            if(message.startsWith('0x')){
                message = ethers.utils.arrayify(message);
            }
            signedMessage = await this.signer.signMessage(
                (message as string));
        }
        console.log(
            'signedMessage', signedMessage, this.isMobileSDK);
        if(this.isMobileSDK){
            console.log('mobile sdkgg');
            let messageType = this.personalMessage ? 'signedPersonalMessage' : 'signedMessage';
            (window as any).location = this.redirectURL + `?${messageType}=${signedMessage}&action=approve&actionType=${messageType}`;
        }
        else{
            let messageType = this.personalMessage?'signedPersonalMessageRetVal' : 'signedMessageRetVal';
            console.log('sending message');
            this.connectedSocketConnection.emit("broadcast", {
                roomId: this.socketUUID,
                data: JSON.stringify({
                    signedMessage: signedMessage,
                    action: 'approve',
                    type: messageType
                }),
            });
        }
    }

    async declineMessageSign(){
        if(this.isMobileSDK){
            window.location.href = this.redirectURL + `?action=decline&actionType=signedMessage`;
        }
        else{
            this.connectedSocketConnection.emit("broadcast", {
                roomId: this.socketUUID,
                data: JSON.stringify({
                    action: 'decline',
                    type: 'signedMessageRetVal',
                    errorReason: 'Signed Message declined by user'
                }),
            });
        }
    }

}
